
define('ldsh!common/templates/trial', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="wrapper">\n  <p>\n    ' +
((__t = ( trialWarning )) == null ? '' : __t) +
' -\n      <a class="ed-btn" data-i18n="trial.actualize" href=' +
((__t = (paymentsUrl + "/account/products?company_id=" + companyId
        )) == null ? '' : __t) +
'></a>\n  </p>\n</div>';

}
return __p
};});

